/**
 * AME Bath & Shower Safety Configurator — guided quiz for bath safety selection
 * ES5 IIFE, no dependencies, deferred loading
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-ame-bs-configurator]');
  if (!root) return;

  // --- DOM refs ---
  var ctaBtn = root.querySelector('[data-bs-cfg-cta]');
  var wizard = root.querySelector('#ame-bs-cfg-wizard');
  var resultsPanel = root.querySelector('[data-bs-cfg-results]');
  var resultsGrid = root.querySelector('[data-bs-cfg-results-grid]');
  var resultsHeading = root.querySelector('[data-bs-cfg-results-heading]');
  var resultsSubtitle = root.querySelector('[data-bs-cfg-results-subtitle]');
  var viewAllLink = root.querySelector('[data-bs-cfg-view-all]');
  var progressLabel = root.querySelector('[data-bs-cfg-progress-label]');
  var progressBar = root.querySelector('[data-bs-cfg-progressbar]');
  var progressFill = root.querySelector('[data-bs-cfg-progress-fill]');
  var liveRegion = root.querySelector('[data-bs-cfg-live]');

  var steps = root.querySelectorAll('[data-bs-cfg-step]');
  var TOTAL_STEPS = steps.length;

  // --- State ---
  var currentStep = 1;
  var answers = {};
  var products = [];

  // --- Parse product data ---
  var dataEl = document.getElementById('ame-bs-cfg-data');
  if (dataEl) {
    try {
      products = JSON.parse(dataEl.textContent);
    } catch (e) {
      products = [];
    }
  }

  // --- Session storage helpers ---
  function saveState() {
    try {
      sessionStorage.setItem('ame-bs-cfg-state', JSON.stringify({
        step: currentStep,
        answers: answers
      }));
    } catch (e) { /* ignore */ }
  }

  function loadState() {
    try {
      var raw = sessionStorage.getItem('ame-bs-cfg-state');
      if (raw) return JSON.parse(raw);
    } catch (e) { /* ignore */ }
    return null;
  }

  function clearState() {
    try { sessionStorage.removeItem('ame-bs-cfg-state'); } catch (e) { /* ignore */ }
  }

  // --- Announce to screen readers ---
  function announce(msg) {
    if (liveRegion) liveRegion.textContent = msg;
  }

  // --- Progress bar ---
  function updateProgress(step) {
    var pct = Math.round((step / TOTAL_STEPS) * 100);
    if (progressLabel) progressLabel.textContent = 'Step ' + step + ' of ' + TOTAL_STEPS;
    if (progressFill) progressFill.style.width = pct + '%';
    if (progressBar) {
      progressBar.setAttribute('aria-valuenow', pct);
    }
  }

  // --- Show/hide steps ---
  function showStep(n) {
    for (var i = 0; i < steps.length; i++) {
      steps[i].classList.toggle('is-active', i === n - 1);
    }
    currentStep = n;
    updateProgress(n);

    var stepEl = steps[n - 1];
    var radios = stepEl.querySelectorAll('input[type="radio"]');
    var fieldName = radios.length > 0 ? radios[0].name : '';
    if (fieldName && answers[fieldName]) {
      for (var j = 0; j < radios.length; j++) {
        radios[j].checked = radios[j].value === answers[fieldName];
      }
    }

    updateNextBtn(stepEl);

    var question = stepEl.querySelector('.ame-bs-cfg__question');
    if (question) question.focus();

    announce('Step ' + n + ' of ' + TOTAL_STEPS);
    saveState();
  }

  // --- Next button enabled/disabled ---
  function updateNextBtn(stepEl) {
    var nextBtn = stepEl.querySelector('[data-bs-cfg-next]');
    var checked = stepEl.querySelector('input[type="radio"]:checked');
    if (nextBtn) nextBtn.disabled = !checked;
  }

  // --- Open wizard ---
  function openWizard() {
    wizard.hidden = false;
    ctaBtn.setAttribute('aria-expanded', 'true');
    showStep(currentStep);
    requestAnimationFrame(function () {
      var rect = wizard.getBoundingClientRect();
      var headerEl = document.querySelector('#shopify-section-header') || document.querySelector('.section-header');
      var headerH = headerEl ? headerEl.getBoundingClientRect().height : 0;
      window.scrollTo({ top: window.scrollY + rect.top - headerH - 16, behavior: 'smooth' });
    });
  }

  // --- Close wizard ---
  function closeWizard() {
    wizard.hidden = true;
    resultsPanel.classList.remove('is-active');
    ctaBtn.setAttribute('aria-expanded', 'false');
    ctaBtn.focus();
    currentStep = 1;
    answers = {};
    clearState();
  }

  // --- Collect answer from current step ---
  function collectAnswer() {
    var stepEl = steps[currentStep - 1];
    var checked = stepEl.querySelector('input[type="radio"]:checked');
    if (checked) {
      answers[checked.name] = checked.value;
    }
  }

  // --- Tag helper ---
  function hasTag(tags, tag) {
    if (!tags || !tags.length) return false;
    for (var i = 0; i < tags.length; i++) {
      if (tags[i] === tag) return true;
    }
    return false;
  }

  // --- Scoring algorithm ---
  function scoreNeed(product, need) {
    var tags = product.tags || [];
    var score = 0;
    switch (need) {
      case 'shower':
        if (hasTag(tags, 'shower-chair')) score += 10;
        if (hasTag(tags, 'bath-bench')) score += 8;
        if (hasTag(tags, 'shower')) score += 5;
        if (hasTag(tags, 'transfer-bench')) score += 3;
        if (hasTag(tags, 'commode') || hasTag(tags, 'raised-seat') || hasTag(tags, 'grab-bar')) score -= 3;
        break;
      case 'transfer':
        if (hasTag(tags, 'transfer-bench')) score += 12;
        if (hasTag(tags, 'transfer')) score += 6;
        if (hasTag(tags, 'bath-bench')) score += 3;
        if (hasTag(tags, 'commode') || hasTag(tags, 'raised-seat') || hasTag(tags, 'grab-bar')) score -= 5;
        break;
      case 'toilet':
        if (hasTag(tags, 'raised-seat')) score += 10;
        if (hasTag(tags, 'commode')) score += 10;
        if (hasTag(tags, 'toilet')) score += 5;
        if (hasTag(tags, 'shower-chair') || hasTag(tags, 'bath-bench') || hasTag(tags, 'grab-bar')) score -= 3;
        break;
      case 'support':
        if (hasTag(tags, 'grab-bar')) score += 12;
        if (hasTag(tags, 'safety-rail')) score += 8;
        if (hasTag(tags, 'support')) score += 5;
        if (hasTag(tags, 'shower-chair') || hasTag(tags, 'commode')) score -= 3;
        break;
    }
    return score;
  }

  function scoreCapacity(product, minCapacity) {
    if (product.weight_capacity === null) return 0;
    if (product.weight_capacity < minCapacity) return -100;
    return 10;
  }

  function scoreFeature(product, feature) {
    var tags = product.tags || [];
    var score = 0;
    switch (feature) {
      case 'padded':
        if (hasTag(tags, 'padded')) score += 8;
        if (hasTag(tags, 'cushioned') || hasTag(tags, 'comfort')) score += 5;
        break;
      case 'rolling':
        if (hasTag(tags, 'rolling')) score += 10;
        if (hasTag(tags, 'wheels') || hasTag(tags, 'wheeled')) score += 6;
        break;
      case 'adjustable':
        if (hasTag(tags, 'adjustable')) score += 10;
        if (hasTag(tags, 'adjustable-height')) score += 5;
        break;
      case 'basic':
        // No filter — all products eligible
        score += 2;
        break;
    }
    return score;
  }

  function scoreProducts(ans) {
    var need = ans.bs_need || 'shower';
    var minCapacity = parseInt(ans.bs_weight, 10) || 300;
    var feature = ans.bs_feature || 'basic';

    var scored = [];
    for (var i = 0; i < products.length; i++) {
      var p = products[i];

      var nScore = scoreNeed(p, need);
      var cScore = scoreCapacity(p, minCapacity);
      var fScore = scoreFeature(p, feature);

      // Weights: need=4, weight=3 (hard), feature=2
      var total = (nScore * 4) + (cScore * 3) + (fScore * 2);

      scored.push({
        product: p,
        total: total,
        needScore: nScore,
        capacityScore: cScore,
        featureScore: fScore
      });
    }

    scored.sort(function (a, b) { return b.total - a.total; });
    return scored;
  }

  // --- Match badge label ---
  function getMatchLabel(index) {
    switch (index) {
      case 0: return 'Best Match';
      case 1: return 'Great Fit';
      case 2: return 'Strong Pick';
      default: return 'Good Option';
    }
  }

  // --- Format price ---
  function formatPrice(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // --- Build spec pills ---
  function buildSpecs(product) {
    var specs = [];
    if (product.weight_capacity) specs.push(product.weight_capacity + ' lb capacity');
    if (product.product_weight) specs.push(product.product_weight + ' lbs');
    return specs.slice(0, 3);
  }

  // --- HTML escaping ---
  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  // --- Render result cards ---
  function renderResults(scored) {
    var top = [];
    for (var i = 0; i < scored.length && top.length < 5; i++) {
      if (scored[i].total > 0) top.push(scored[i]);
    }

    if (top.length === 0 && scored.length > 0) {
      for (var f = 0; f < scored.length && top.length < 3; f++) {
        top.push(scored[f]);
      }
    }

    resultsGrid.innerHTML = '';

    if (top.length === 0) {
      resultsGrid.innerHTML =
        '<div class="ame-bs-cfg__no-match">' +
          '<p>No exact matches found for your criteria.</p>' +
          '<p>Try adjusting your preferences or <a href="tel:+18039261493">call (803) 926-1493</a> for expert help.</p>' +
        '</div>';
      resultsSubtitle.textContent = '';
      announce('No exact matches found. Try adjusting your preferences or call for help.');
      return top;
    }

    if (top[0].total <= 0) {
      resultsSubtitle.textContent =
        'We couldn\'t find an exact match, but here are our closest options. ' +
        'Call (803) 926-1493 for personalized help.';
    } else {
      resultsSubtitle.textContent = 'Based on your answers, here are our top ' + top.length + ' recommendations.';
    }

    for (var j = 0; j < top.length; j++) {
      var p = top[j].product;
      var specs = buildSpecs(p);
      var specsHtml = '';
      for (var k = 0; k < specs.length; k++) {
        specsHtml += '<span class="ame-bs-cfg__card-spec">' + escapeHtml(specs[k]) + '</span>';
      }

      var priceHtml = '';
      if (p.call_for_price) {
        priceHtml = '<span style="color:var(--ame-primary)">Call for Price</span>';
      } else {
        priceHtml = formatPrice(p.price);
        if (p.compare_at_price && p.compare_at_price > p.price) {
          priceHtml += ' <span class="ame-card__compare-price">' + formatPrice(p.compare_at_price) + '</span>';
        }
      }

      var vendorHtml = p.vendor ? '<span class="ame-card__vendor">' + escapeHtml(p.vendor) + '</span>' : '';

      var card =
        '<a href="' + escapeHtml(p.url) + '" class="ame-card">' +
          '<div class="ame-card__image-wrap">' +
            '<span class="ame-bs-cfg__match-badge">' + getMatchLabel(j) + '</span>' +
            (p.image ? '<img class="ame-card__image" src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="500" height="500">' : '') +
          '</div>' +
          '<div class="ame-card__body">' +
            vendorHtml +
            '<h3 class="ame-card__title">' + escapeHtml(p.title) + '</h3>' +
            '<div class="ame-bs-cfg__card-specs">' + specsHtml + '</div>' +
            '<div class="ame-card__price">' + priceHtml + '</div>' +
          '</div>' +
        '</a>';

      resultsGrid.insertAdjacentHTML('beforeend', card);
    }

    announce('Found ' + top.length + ' matching bath safety products. Showing your top recommendations.');
    return top;
  }

  // --- Build filter URL for "View All" ---
  function buildFilterUrl(ans) {
    var base = '/collections/bath-shower-chairs';
    var params = [];

    if (ans.bs_need) {
      switch (ans.bs_need) {
        case 'shower':
          params.push('filter.p.tag=shower-chair');
          break;
        case 'transfer':
          params.push('filter.p.tag=transfer-bench');
          break;
        case 'toilet':
          params.push('filter.p.tag=raised-seat');
          break;
        case 'support':
          params.push('filter.p.tag=grab-bar');
          break;
      }
    }

    return params.length > 0 ? base + '?' + params.join('&') : base;
  }

  // --- Show results ---
  function showResults() {
    wizard.hidden = true;
    var scored = scoreProducts(answers);
    var top = renderResults(scored);

    if (viewAllLink) viewAllLink.href = buildFilterUrl(answers);

    resultsPanel.classList.add('is-active');
    if (resultsHeading) resultsHeading.focus();

    clearState();
  }

  // --- Event: CTA click ---
  ctaBtn.addEventListener('click', function () {
    if (wizard.hidden && !resultsPanel.classList.contains('is-active')) {
      openWizard();
    } else {
      closeWizard();
    }
  });

  // --- Event: radio change ---
  root.addEventListener('change', function (e) {
    if (e.target.type === 'radio' && e.target.closest('[data-bs-cfg-step]')) {
      var stepEl = e.target.closest('[data-bs-cfg-step]');
      updateNextBtn(stepEl);
    }
  });

  // --- Event: next ---
  root.addEventListener('click', function (e) {
    var nextBtn = e.target.closest('[data-bs-cfg-next]');
    if (!nextBtn || nextBtn.disabled) return;

    collectAnswer();

    if (currentStep < TOTAL_STEPS) {
      showStep(currentStep + 1);
    } else {
      showResults();
    }
  });

  // --- Event: back ---
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-bs-cfg-back]')) {
      collectAnswer();
      if (currentStep > 1) {
        showStep(currentStep - 1);
      }
    }
  });

  // --- Event: close ---
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-bs-cfg-close]')) {
      closeWizard();
    }
  });

  // --- Event: restart ---
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-bs-cfg-restart]')) {
      resultsPanel.classList.remove('is-active');
      answers = {};
      currentStep = 1;

      var radios = root.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        radios[i].checked = false;
      }

      clearState();
      openWizard();
    }
  });

  // --- Event: Banner CTA ---
  var bannerCta = document.querySelector('[data-cfg-banner-cta]');
  if (bannerCta) {
    bannerCta.addEventListener('click', function () {
      openWizard();
    });
  }

  // --- Event: Escape key ---
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && !wizard.hidden) {
      closeWizard();
    }
  });

  // --- Restore session ---
  var saved = loadState();
  if (saved && saved.step && saved.answers) {
    answers = saved.answers;
    currentStep = saved.step;

    var fieldNames = Object.keys(answers);
    for (var f = 0; f < fieldNames.length; f++) {
      var radio = root.querySelector('input[name="' + fieldNames[f] + '"][value="' + answers[fieldNames[f]] + '"]');
      if (radio) radio.checked = true;
    }

    openWizard();
  }
})();
